/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * ScaleFi Nub APIs
 * Scale Fi Apis
 * OpenAPI spec version: v0.0.1
 */
import {
  useInfiniteQuery,
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteData,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseInfiniteQueryOptions,
  UseInfiniteQueryResult,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  SelfOnboardingConfigDTO
} from '../model';

import { customInstance } from '../mutator/custom-instance';



type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



/**
 * Get all self-onboarding configurations
 * @summary Get all configs
 */
export const getAllConfigs = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SelfOnboardingConfigDTO[]>(
      {url: `/frontend/admin/self-onboarding-configs`, method: 'GET', signal
    },
      options);
    }
  



export const getGetAllConfigsInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/admin/self-onboarding-configs`
    ] as const;
    }

export const getGetAllConfigsQueryKey = () => {
    return [
    `/frontend/admin/self-onboarding-configs`
    ] as const;
    }

    
export const getGetAllConfigsInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getAllConfigs>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllConfigsInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllConfigs>>> = ({ signal }) => getAllConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllConfigsInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getAllConfigs>>>
export type GetAllConfigsInfiniteQueryError = unknown


export function useGetAllConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllConfigs>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configs
 */

export function useGetAllConfigsInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getAllConfigs>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllConfigsInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetAllConfigsQueryOptions = <TData = Awaited<ReturnType<typeof getAllConfigs>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetAllConfigsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getAllConfigs>>> = ({ signal }) => getAllConfigs(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetAllConfigsQueryResult = NonNullable<Awaited<ReturnType<typeof getAllConfigs>>>
export type GetAllConfigsQueryError = unknown


export function useGetAllConfigs<TData = Awaited<ReturnType<typeof getAllConfigs>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigs<TData = Awaited<ReturnType<typeof getAllConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getAllConfigs>>,
          TError,
          Awaited<ReturnType<typeof getAllConfigs>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetAllConfigs<TData = Awaited<ReturnType<typeof getAllConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get all configs
 */

export function useGetAllConfigs<TData = Awaited<ReturnType<typeof getAllConfigs>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getAllConfigs>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetAllConfigsQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Update an existing self-onboarding configuration
 * @summary Update config
 */
export const updateConfig = (
    selfOnboardingConfigDTO: SelfOnboardingConfigDTO,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SelfOnboardingConfigDTO>(
      {url: `/frontend/admin/self-onboarding-configs`, method: 'PUT',
      headers: {'Content-Type': 'application/json', },
      data: selfOnboardingConfigDTO
    },
      options);
    }
  


export const getUpdateConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext> => {

const mutationKey = ['updateConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateConfig>>, {data: SelfOnboardingConfigDTO}> = (props) => {
          const {data} = props ?? {};

          return  updateConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type UpdateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof updateConfig>>>
    export type UpdateConfigMutationBody = SelfOnboardingConfigDTO
    export type UpdateConfigMutationError = unknown

    /**
 * @summary Update config
 */
export const useUpdateConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateConfig>>,
        TError,
        {data: SelfOnboardingConfigDTO},
        TContext
      > => {

      const mutationOptions = getUpdateConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Create a new self-onboarding configuration
 * @summary Create config
 */
export const createConfig = (
    selfOnboardingConfigDTO: SelfOnboardingConfigDTO,
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SelfOnboardingConfigDTO>(
      {url: `/frontend/admin/self-onboarding-configs`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: selfOnboardingConfigDTO, signal
    },
      options);
    }
  


export const getCreateConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext> => {

const mutationKey = ['createConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createConfig>>, {data: SelfOnboardingConfigDTO}> = (props) => {
          const {data} = props ?? {};

          return  createConfig(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreateConfigMutationResult = NonNullable<Awaited<ReturnType<typeof createConfig>>>
    export type CreateConfigMutationBody = SelfOnboardingConfigDTO
    export type CreateConfigMutationError = unknown

    /**
 * @summary Create config
 */
export const useCreateConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createConfig>>, TError,{data: SelfOnboardingConfigDTO}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createConfig>>,
        TError,
        {data: SelfOnboardingConfigDTO},
        TContext
      > => {

      const mutationOptions = getCreateConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Set a self-onboarding configuration as active
 * @summary Set active config
 */
export const setActiveConfig = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<SelfOnboardingConfigDTO>(
      {url: `/frontend/admin/self-onboarding-configs/${id}/activate`, method: 'PUT'
    },
      options);
    }
  


export const getSetActiveConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof setActiveConfig>>, TError,{id: number}, TContext> => {

const mutationKey = ['setActiveConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof setActiveConfig>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  setActiveConfig(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type SetActiveConfigMutationResult = NonNullable<Awaited<ReturnType<typeof setActiveConfig>>>
    
    export type SetActiveConfigMutationError = unknown

    /**
 * @summary Set active config
 */
export const useSetActiveConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof setActiveConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof setActiveConfig>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getSetActiveConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    /**
 * Check if self-registration is enabled
 * @summary Can self-register
 */
export const canSelfRegister = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<boolean>(
      {url: `/frontend/admin/self-onboarding-configs/can-self-register`, method: 'GET', signal
    },
      options);
    }
  



export const getCanSelfRegisterInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/admin/self-onboarding-configs/can-self-register`
    ] as const;
    }

export const getCanSelfRegisterQueryKey = () => {
    return [
    `/frontend/admin/self-onboarding-configs/can-self-register`
    ] as const;
    }

    
export const getCanSelfRegisterInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof canSelfRegister>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanSelfRegisterInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof canSelfRegister>>> = ({ signal }) => canSelfRegister(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CanSelfRegisterInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof canSelfRegister>>>
export type CanSelfRegisterInfiniteQueryError = unknown


export function useCanSelfRegisterInfinite<TData = InfiniteData<Awaited<ReturnType<typeof canSelfRegister>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canSelfRegister>>,
          TError,
          Awaited<ReturnType<typeof canSelfRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCanSelfRegisterInfinite<TData = InfiniteData<Awaited<ReturnType<typeof canSelfRegister>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canSelfRegister>>,
          TError,
          Awaited<ReturnType<typeof canSelfRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCanSelfRegisterInfinite<TData = InfiniteData<Awaited<ReturnType<typeof canSelfRegister>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Can self-register
 */

export function useCanSelfRegisterInfinite<TData = InfiniteData<Awaited<ReturnType<typeof canSelfRegister>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCanSelfRegisterInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getCanSelfRegisterQueryOptions = <TData = Awaited<ReturnType<typeof canSelfRegister>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCanSelfRegisterQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof canSelfRegister>>> = ({ signal }) => canSelfRegister(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type CanSelfRegisterQueryResult = NonNullable<Awaited<ReturnType<typeof canSelfRegister>>>
export type CanSelfRegisterQueryError = unknown


export function useCanSelfRegister<TData = Awaited<ReturnType<typeof canSelfRegister>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof canSelfRegister>>,
          TError,
          Awaited<ReturnType<typeof canSelfRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCanSelfRegister<TData = Awaited<ReturnType<typeof canSelfRegister>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof canSelfRegister>>,
          TError,
          Awaited<ReturnType<typeof canSelfRegister>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useCanSelfRegister<TData = Awaited<ReturnType<typeof canSelfRegister>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Can self-register
 */

export function useCanSelfRegister<TData = Awaited<ReturnType<typeof canSelfRegister>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof canSelfRegister>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getCanSelfRegisterQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Get the active self-onboarding configuration
 * @summary Get active config
 */
export const getActiveConfig = (
    
 options?: SecondParameter<typeof customInstance>,signal?: AbortSignal
) => {
      
      
      return customInstance<SelfOnboardingConfigDTO>(
      {url: `/frontend/admin/self-onboarding-configs/active`, method: 'GET', signal
    },
      options);
    }
  



export const getGetActiveConfigInfiniteQueryKey = () => {
    return [
    'infinite', `/frontend/admin/self-onboarding-configs/active`
    ] as const;
    }

export const getGetActiveConfigQueryKey = () => {
    return [
    `/frontend/admin/self-onboarding-configs/active`
    ] as const;
    }

    
export const getGetActiveConfigInfiniteQueryOptions = <TData = InfiniteData<Awaited<ReturnType<typeof getActiveConfig>>>, TError = unknown>( options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveConfigInfiniteQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveConfig>>> = ({ signal }) => getActiveConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveConfigInfiniteQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveConfig>>>
export type GetActiveConfigInfiniteQueryError = unknown


export function useGetActiveConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActiveConfig>>>, TError = unknown>(
  options: { query:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfig>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActiveConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfig>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActiveConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get active config
 */

export function useGetActiveConfigInfinite<TData = InfiniteData<Awaited<ReturnType<typeof getActiveConfig>>>, TError = unknown>(
  options?: { query?:Partial<UseInfiniteQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveConfigInfiniteQueryOptions(options)

  const query = useInfiniteQuery(queryOptions, queryClient) as  UseInfiniteQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




export const getGetActiveConfigQueryOptions = <TData = Awaited<ReturnType<typeof getActiveConfig>>, TError = unknown>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetActiveConfigQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getActiveConfig>>> = ({ signal }) => getActiveConfig(requestOptions, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type GetActiveConfigQueryResult = NonNullable<Awaited<ReturnType<typeof getActiveConfig>>>
export type GetActiveConfigQueryError = unknown


export function useGetActiveConfig<TData = Awaited<ReturnType<typeof getActiveConfig>>, TError = unknown>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfig>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfig<TData = Awaited<ReturnType<typeof getActiveConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getActiveConfig>>,
          TError,
          Awaited<ReturnType<typeof getActiveConfig>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useGetActiveConfig<TData = Awaited<ReturnType<typeof getActiveConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
/**
 * @summary Get active config
 */

export function useGetActiveConfig<TData = Awaited<ReturnType<typeof getActiveConfig>>, TError = unknown>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getActiveConfig>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getGetActiveConfigQueryOptions(options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




/**
 * Delete a self-onboarding configuration
 * @summary Delete config
 */
export const deleteConfig = (
    id: number,
 options?: SecondParameter<typeof customInstance>,) => {
      
      
      return customInstance<void>(
      {url: `/frontend/admin/self-onboarding-configs/${id}`, method: 'DELETE'
    },
      options);
    }
  


export const getDeleteConfigMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{id: number}, TContext> => {

const mutationKey = ['deleteConfig'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteConfig>>, {id: number}> = (props) => {
          const {id} = props ?? {};

          return  deleteConfig(id,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DeleteConfigMutationResult = NonNullable<Awaited<ReturnType<typeof deleteConfig>>>
    
    export type DeleteConfigMutationError = unknown

    /**
 * @summary Delete config
 */
export const useDeleteConfig = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteConfig>>, TError,{id: number}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteConfig>>,
        TError,
        {id: number},
        TContext
      > => {

      const mutationOptions = getDeleteConfigMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    